import React from 'react';

import { TimeTableComponent } from '../components/time-table.component';

export const TimeTableContainer = () => (
  // <PreferTimeContextProvider>
  <TimeTableComponent />
  // </PreferTimeContextProvider>
);
